module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "slide-instagram"
  }, [_c('div', {
    staticClass: "slide-instagram__image",
    style: ({
      backgroundImage: 'url(' + _vm.slide.media + ')'
    })
  }), (_vm.slide.date) ? _c('div', {
    staticClass: "slide-instagram__date"
  }, [_vm._v(_vm._s(_vm.slide.date.format("DD"))), _c('br'), _vm._v("\n" + _vm._s(_vm.month) + "."), _c('br'), _vm._v("\n" + _vm._s(_vm.slide.date.format("YYYY")))]) : _vm._e(), (_vm.slide.date) ? _c('div', {
    staticClass: "slide-instagram__content"
  }, [_c('div', {
    staticClass: "slide-instagram__content__wrapper"
  }, [(_vm.description) ? _c('div', {
    staticClass: "slide-instagram__content__title",
    attrs: {
      "tabindex": "0",
      "aria-label": "Title"
    }
  }, [_vm._v(_vm._s(_vm.slide.date.format("LT")) + " - " + _vm._s(_vm.description))]) : _vm._e(), (!_vm.description) ? _c('div', {
    staticClass: "slide-instagram__content__title",
    attrs: {
      "tabindex": "0",
      "aria-label": "Title"
    }
  }, [_vm._v(_vm._s(_vm.slide.date.format("LT")))]) : _vm._e()])]) : _vm._e()])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-3c8a4a8a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c8a4a8a"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/slider/slide-instagram/SlideInstagramComponent.vue
// module id = 817
// module chunks = 0